export default __webpack_public_path__ + "static/media/star.1a9e3bf0.svg";